import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "../shared/auth/AuthContext";
import { DevServerSwitcher } from "../shared/components/DevServerSwitcher";

import GameSummary from "./pages/GameSummary";
import { NavLayout } from "./layouts/NavLayout";
import Games from "./pages/Games";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import Welcome from "./pages/Welcome";
import MatchSummary from "./pages/MatchSummary";
import Matches from "./pages/Matches";
import Home from "./pages/Home";
import GameEdit from "./pages/GameEdit";
import GameCreate from "./pages/GameCreate";
import DiscordLink from "./pages/DiscordLink";
import Features from "./pages/Features";
import Develop from "./pages/Develop";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AdminPanel from "./pages/AdminPanel";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <DevServerSwitcher />
      <BrowserRouter basename="/spa">
        <ScrollToTop />
        <NavLayout>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/develop" element={<Develop />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/discord/link/:id" element={<DiscordLink />} />
          <Route path="/match" element={<Matches />} />
          <Route path="/login" element={<Login />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/match/:matchId" element={<MatchSummary />} />
          <Route path="/creategame" element={<GameCreate />} />
          <Route path="/game" element={<Games />} />
          <Route path="/game/:name" element={<GameSummary />} />
          <Route path="/game/:name/edit" element={<GameEdit />} />
          <Route
            path="/game/:name/version/:version"
            element={<GameSummary />}
          />
          <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </NavLayout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
